import _ from 'lodash';

import { showModal } from './show-modal';
import { INFO_NOTIFICATION, SUCCESS_MESSAGE_NOTIFICATION } from '../constants/modal-types';
import { isInWix } from '../services/is-in-wix';
import { getConfig } from '../services/config';
import Wix from '../services/wix-sdk-polyfill';
import { getIsMobile } from '../state/site/selectors';
import { MODAL_CONFIRM, MODAL_CLOSE } from '../constants/modal-events';

const URI = require('urijs');

// TODO: rename this to 'modal.js'
const getMobileNotificationSettings = (isTopCenter) => ({
  width: '100%',
  height: '0px',
  positioning: {
    origin: Wix.WindowOrigin.FIXED,
    placement: isTopCenter ? Wix.WindowPlacement.TOP_CENTER : Wix.WindowPlacement.BOTTOM_CENTER,
  },
});
const DESKTOP_NOTIFICATION_SETTINGS = {
  width: '450px',
  height: '0px',
  positioning: {
    origin: Wix.WindowOrigin.FIXED,
    placement: Wix.WindowPlacement.TOP_CENTER,
  },
};
const DESKTOP_NOTIFICATION_FW_SETTINGS = {
  width: '100%',
  height: '0px',
  positioning: {
    origin: Wix.WindowOrigin.FIXED,
    placement: Wix.WindowPlacement.TOP_CENTER,
  },
};

const openWixModal = (
  url,
  {
    width = '100%',
    height = '100%',
    onClose = _.noop,
    positioning = {
      origin: Wix.WindowOrigin.FIXED,
      placement: Wix.WindowPlacement.CENTER,
    },
  } = {},
) => {
  if (isInWix()) {
    Wix.openPopup(url, width, height, positioning, onClose, Wix.Theme.BARE);
  }
};

const dataToBase64 = (data) => data && btoa(escape(JSON.stringify(data)));

const buildUrl = (url, props, query = {}) =>
  new URI(url)
    .query({
      data: dataToBase64(props),
      sectionUrl: getConfig().sectionUrl,
      isPopup: true,
      ...query,
    })
    .toString();

export const openInternalUrlAsModal = (internalRoute, modalProps, props, query) => (
  dispatch,
  getState,
  { baseUrl },
) => {
  const url = buildUrl(`${baseUrl}${internalRoute}`, props, query);
  openWixModal(url, modalProps);
};

export const openModal = (type, props) => (dispatch, getState, { baseUrl }) => {
  dispatch(showModal(type, props));
  const url = buildUrl(`${baseUrl}app/modal/${type}`, props);
  openWixModal(url);
};

export const openNotification = (props) => (dispatch, getState, { baseUrl }) => {
  const settings = getIsMobile(getState())
    ? getMobileNotificationSettings(props.isTopCenter)
    : DESKTOP_NOTIFICATION_SETTINGS;
  dispatch(showModal(SUCCESS_MESSAGE_NOTIFICATION, props));
  const url = buildUrl(`${baseUrl}app/modal/${SUCCESS_MESSAGE_NOTIFICATION}`, props);
  openWixModal(url, settings);
};

export const openInfoNotification = (props) => (dispatch, getState, { baseUrl }) => {
  const settings = getIsMobile(getState())
    ? getMobileNotificationSettings(props.isTopCenter)
    : DESKTOP_NOTIFICATION_FW_SETTINGS;
  dispatch(showModal(INFO_NOTIFICATION, props));
  const url = buildUrl(`${baseUrl}app/modal/${INFO_NOTIFICATION}`, props);
  openWixModal(url, settings);
};

export const openModalWithCallback = (type, onConfirm, props) => (dispatch) => {
  // eslint-disable-next-line prefer-const
  let id1, id2;

  const unsubscribe = () => {
    Wix.PubSub.unsubscribe(MODAL_CLOSE, id1);
    Wix.PubSub.unsubscribe(MODAL_CONFIRM, id2);
  };

  const confirmAction = ({ data }) => {
    onConfirm(data);
    unsubscribe();
  };

  id1 = Wix.PubSub.subscribe(MODAL_CLOSE, unsubscribe);
  id2 = Wix.PubSub.subscribe(MODAL_CONFIRM, confirmAction);

  dispatch(openModal(type, props));
};
